import styled, { css } from 'styled-components'

export const TicketFieldRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`

export const TicketFieldLabel = styled.label`
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 6px;
  color: #344054;
`

export const TicketTextArea = styled.textarea<{ hasError: boolean }>`
  padding: 10px;
  border-radius: 4px;
  ${({ hasError }) => css`
    border: 1px solid
      ${({ theme }) => (hasError ? theme.colors.brandRed.main : theme.colors.grayscale.gray20)};
  `};
  min-height: 128px;
  resize: vertical;
`

export const TicketFieldsError = styled.div`
  margin-top: -15px;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.colors.brandRed.main};
`
